import React from "react";
import { Link } from "react-router-dom";
import AdminHeader from "../../components/AdminHeader";

export default function AdminCentralHome() {

  const cards = [
    { title: "Producción", desc: "Crear activos", to: "/admin/produccion" },
    { title: "Productos", desc: "Packaging y oferta", to: "/admin/productos" },
    { title: "G.A.U", desc: "CRM ZEDRO", to: "/admin/miembros" },
    { title: "Crecimiento", desc: "Marketing y ventas", to: "/admin/crecimiento" },
    { title: "Sistema", desc: "Backoffice y control", to: "/admin/sistema" },
  ];

  return (
    <>
      <AdminHeader />

      <main
        style={{
          maxWidth: 1000,
          margin: "2rem auto",
          fontFamily: "Questrial, sans-serif",
          padding: "0 16px",
        }}
      >

        <section
          style={{
            background: "#fff",
            border: "1px solid #e6ebf1",
            borderRadius: 14,
            padding: "18px 18px",
            boxShadow: "0 10px 30px rgba(0,0,0,.05)",
          }}
        >

          <div
            style={{
              fontSize: 12,
              letterSpacing: ".16em",
              textTransform: "uppercase",
              color: "rgba(44,59,81,.55)",
              fontWeight: 800,
              marginBottom: 6,
            }}
          >
            ZEDRO ACADEMY
          </div>

          <h1
            style={{
              margin: 0,
              fontFamily: "Bitter, serif",
              fontSize: 28,
              color: "#0a2230",
              fontWeight: 800,
            }}
          >
            BIENVENIDOS!
          </h1>

          <p
            style={{
              margin: "0.35rem 0 0",
              color: "#6b7a88",
              fontSize: "0.95rem",
              lineHeight: 1.5,
            }}
          >
            Accesos a las áreas de negocio de ZEDRO.
          </p>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
              gap: 12,
              marginTop: 14,
            }}
          >
            {cards.map((c) => (
              <Link
                key={c.title}
                to={c.to}
                style={{
                  border: "1px solid #e6ebf1",
                  borderRadius: 12,
                  padding: "12px 12px",
                  background: "#fff",
                  textDecoration: "none",
                }}
              >
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                  <div>
                    <div style={{ fontWeight: 900, color: "#0a2230", fontSize: 16 }}>
                      {c.title} →
                    </div>
                    <div style={{ marginTop: 6, color: "#6b7a88", fontSize: "0.9rem" }}>
                      {c.desc}
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>

        </section>

      </main>
    </>
  );
}